const mfaEnterCodeTemplate = `
<div 
   class="col-md-6 col-md-offset-3 col-sm-8 col-sm-offset-2 registration"
   data-ng-init="OneIdMfaController.dataForNoContactInfoModal()"
>
   <div class="inner-container with-padding with-shadow">
      <div class="block-title-linking" data-ng-repeat="planValue in plansFromCurrentContext">
         <b>{{planValue.planName}}</b>
      </div>

      <header class="contained-form-header margin-top-default">

         <p> {{ 'linkingMFACodeVal.intro' | translate }} </p>
      </header>

      <form role="form" id="oneIdVerificationForm" name="oneIdVerificationForm" autocomplete="off" novalidate
         data-ng-submit="  OneIdMfaController.validateOneIdMFACode()">
         <!--todo: this should be a directive-->
         <div data-ng-show="verificationMessage !== null" class="form-group has-error">
            <span class="help-block">{{verificationMessage}}</span>
         </div>

         <div data-ng-show="mfa.errorMessage !='' && mfa.errorMessage !=null && mfa.errorMessage!='undefined'"
            class="form-group has-error">
            <span class="help-block" translate="{{mfa.errorMessage}}"
               translate-default="We are unable to send verification codes at this time. Please try again. Contact a Participant Services Representative if the problem continues."></span>
         </div>

         <a href="#" ng-if="displayFieldError('verificationCode');" id="screenReader" class="sr-only"
            ng-click="focusOnErrorInput($event, 'verification_codeInput')">
            <ng-messages for="getFieldError('verificationCode');" ng-if="displayFieldError('verificationCode');"
               class="form-group has-error">
               <ng-message when="required">{{"verificationcodeRequired" | translate }}</ng-message>
            </ng-messages>, Focus invalid input.
         </a>

         <div class="form-group" data-ng-class="OneIdMfaController.getFormGroupClass('verificationCode');">
            <label for="verification_codeInput" class="control-label">{{"pleaseEnterCode" | translate}}</label>
            <input type="tel" class="form-control" id="verification_codeInput" name="verificationCode" auto-focus
               data-ng-required="true" data-activationcode-validator data-mask="99999999" data-mask-restrict="accept"
               data-mask-clean="true" maxlength="8" data-ng-model="verification.verificationCode"
               data-ng-model-options="{ updateOn: 'blur', allowInvalid: true }" ng-blur="activationCodeChange()" />
            <ng-messages for="OneIdMfaController.getFieldError('verificationCode');"
               ng-if="OneIdMfaController.displayFieldError('verificationCode');" class="form-group has-error">
               <ng-message when="required">{{"verificationcodeRequired" | translate }}</ng-message>
            </ng-messages>
         </div>

         <div class="row cta investment-button-row">
            <button class="btn btn-link btn-link-oneid" ui-sref="oneIdMfaActivationCode" id="nocode" type="button">
               {{'linkingMFACodeVal.notReceivedCode' | translate}}
            </button>
            <button 
               id="submitButton" 
               type="submit" 
               class="btn btn-primary pull-right oneid-button-large outline-btn"
               ng-disabled="showSpinner==true"
            >
               <span data-ng-hide="showSpinner==true" id="signin">
                  {{ 'linkingMFACodeVal.submit' | translate }}
               </span>

               <span data-ng-show="showSpinner==true" id="signin">
                  <i class="fa fa-circle-o-notch fa-spin"></i>
                  Processing ...
               </span>
            </button>
         </div>
      </form>
   </div>
   <!--/inner-container with-padding with-shadow/-->
   <!--todo: reformat to common component-->
</div>
`;
export default mfaEnterCodeTemplate;
